/*========================================================================
* $Id: searchform.js 73821 2013-07-17 11:51:32Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "client/template",
    "component!base",
    "!!raw-loader!../mustache/resultcounttemplate.mustache"
  ], function(
    Template,
    Component,
    RESULT_COUNT_DEFAULT_TEMPLATE
  ) {

    var ResultCountTemplate = Template.extend({
      hasContent: function () {
        return true;
      },

      getDefaultTemplate: function () {
        return RESULT_COUNT_DEFAULT_TEMPLATE && RESULT_COUNT_DEFAULT_TEMPLATE.default;
      }

    });

    ResultCountTemplate.View = Component.extend({
    });

    return ResultCountTemplate;
});
